import { fontSize, size } from '@styles/theme'
import capitalize from '@utils/capitalize'
import styled from '@emotion/styled/macro'

import { TempStatusMetaIcon } from '@elements/icons/TempStatusMetaIcon'
import { StatusIcon } from '@elements/StatusIndicator'

const SubTopbarContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  position: fixed;
  left: 0;
  top: ${size(7)};
  z-index: 2;
  
  height: ${size(4)};
  width: 100dvw;
  padding: 0 ${size(1.75)};
  border-bottom: 0.5px solid rgba(255,255,255, 0.15);
  border-top: 0.5px solid rgba(255,255,255, 0.15);

  font-size: ${fontSize('xs')};
  font-weight: 500;
  
  background-color: rgba(20,20,20, 0.9);
  backdrop-filter: blur(10px);
  color: lightgrey;
`

const SubBarStatus = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  flex-shrink: 0;
`

const SubBarStatusText = styled.div`
  padding-left: ${size(0.5)};
`

const SubBarDetails = styled.div`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const rightNowMapping = {
  hosting: {
    hosting: 'Hosting',
    traveling: 'Wants To Travel',
    host_or_travel: 'Host or Travel',
  },
  position: {
    top: 'Topping',
    bottom: 'Bottoming',
    verse: 'Top or Bottom',
    side: 'Oral Only',
  },
}

const SubTopbar = ({ user }) => {
  const isRightNow = user?.tempStatus === 'right_now'
  const hostingText = rightNowMapping?.['hosting']?.[user?.tempStatusMeta?.hosting]
  const positionText = rightNowMapping?.['position']?.[user?.tempStatusMeta?.position]

  const renderHostingText = () => {
    if (isRightNow && hostingText) {
      return (
        <>
          &nbsp;
          &nbsp;
          <TempStatusMetaIcon
            accessor='hosting'
            value={user?.tempStatusMeta?.hosting}
            size={1.5}
            style={{ marginBottom: size(-0.15) }}
          />
          &nbsp;
          {hostingText}
          &nbsp;
        </>
      )
    }
  }

  const renderPositionText = () => {
    if (isRightNow && positionText) {
      return (
        <>
          &nbsp;
          &nbsp;
          <TempStatusMetaIcon
            accessor='position'
            value={user?.tempStatusMeta?.position}
            size={1.5}
            style={{ marginBottom: size(-0.15) }}
          />
          &nbsp;
          {positionText}
          &nbsp;
        </>
      )
    }
  }

  return (
    <SubTopbarContainer>
      <SubBarStatus>
        <StatusIcon status={user?.tempStatus} size={size(1.75)} />
        <SubBarStatusText>
          {capitalize(user?.tempStatus?.replaceAll?.('_', ' ') )}
        </SubBarStatusText>
      </SubBarStatus>
      <SubBarDetails>
        {renderPositionText()}
        {renderHostingText()}
        &nbsp;&nbsp;-&nbsp;&nbsp;{user?.extendedInfos?.tagline || '🙂 Ask me, to learn more.'}
      </SubBarDetails>
    </SubTopbarContainer>
  )
}

export { SubTopbar }
